// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","caption":"_1dJD2pSCq2-UhXWE_3mRfd","actionButton":"j-ZIiVnKCroJ2iZN8wdMC","actionText":"_39EfMVXp_2JvKNZhMze9QM _1dJD2pSCq2-UhXWE_3mRfd"};


//////////////////
// WEBPACK FOOTER
// ./src/common/compare-section/collapse-button/CollapseButton.css
// module id = 962
// module chunks = 1